<div class="game-stat" *ngIf="game && statistic">
  <div class="stats-values">
    <ng-container *ngIf="game.team.sport.isStreetball()">
      <div class="stat-row" *ngIf="isLight">
        <div class="value">{{ statistic.team.onePointsMade || 0 }}</div>
        <div class="name">1-очковых</div>
        <div class="value">{{ statistic.competitorTeam.onePointsMade || 0 }}</div>
      </div>
      <div class="stat-row">
        <div class="value">{{ statistic.team.onePointPercent || 0 }}%</div>
        <div class="name">% 1-очковых</div>
        <div class="value">{{ statistic.competitorTeam.onePointPercent || 0 }}%</div>
      </div>
    </ng-container>
    <div class="stat-row" *ngIf="isLight">
      <div class="value">{{ statistic.team.twoPointsMade || 0 }}</div>
      <div class="name">2-очковых</div>
      <div class="value">{{ statistic.competitorTeam.twoPointsMade || 0 }}</div>
    </div>
    <div class="stat-row">
      <div class="value">{{ statistic.team.twoPointPercent || 0 }}%</div>
      <div class="name">% 2-очковых</div>
      <div class="value">{{ statistic.competitorTeam.twoPointPercent || 0 }}%</div>
    </div>
    <ng-container *ngIf="!game.team.sport.isStreetball()">
      <div class="stat-row" *ngIf="isLight">
        <div class="value">{{ statistic.team.threePointsMade || 0 }}</div>
        <div class="name">3-очковых</div>
        <div class="value">{{ statistic.competitorTeam.threePointsMade || 0 }}</div>
      </div>
      <div class="stat-row">
        <div class="value">{{ statistic.team.threePointPercent || 0 }}%</div>
        <div class="name">% 3-очковых</div>
        <div class="value">{{ statistic.competitorTeam.threePointPercent || 0 }}%</div>
      </div>
    </ng-container>
    <div class="stat-row" *ngIf="isLight">
      <div class="value">{{ statistic.team.freeThrowsMade || 0 }}</div>
      <div class="name">% штрафных</div>
      <div class="value">{{ statistic.competitorTeam.freeThrowPercent || 0 }}%</div>
    </div>
    <div class="stat-row">
      <div class="value">{{ statistic.team.freeThrowPercent || 0 }}%</div>
      <div class="name">% штрафных</div>
      <div class="value">{{ statistic.competitorTeam.freeThrowPercent || 0 }}%</div>
    </div>
    <ng-container *ngIf="!isLight">
      <div class="stat-row">
        <div class="value">{{ statistic.team.rebounds || 0 }}</div>
        <div class="name">Подборы</div>
        <div class="value">{{ statistic.competitorTeam.rebounds || 0 }}</div>
      </div>
      <div class="stat-row">
        <div class="value">{{ statistic.team.defensiveRebounds || 0 }}</div>
        <div class="name">Подборы в защите</div>
        <div class="value">{{ statistic.competitorTeam.defensiveRebounds || 0 }}</div>
      </div>
      <div class="stat-row">
        <div class="value">{{ statistic.team.offensiveRebounds || 0 }}</div>
        <div class="name">Подборы в нападении</div>
        <div class="value">{{ statistic.competitorTeam.offensiveRebounds || 0 }}</div>
      </div>
      <div class="stat-row">
        <div class="value">{{ statistic.team.assists || 0 }}</div>
        <div class="name">Передачи</div>
        <div class="value">{{ statistic.competitorTeam.assists || 0 }}</div>
      </div>
      <div class="stat-row">
        <div class="value">{{ statistic.team.steals || 0 }}</div>
        <div class="name">Перехваты</div>
        <div class="value">{{ statistic.competitorTeam.steals || 0 }}</div>
      </div>
      <div class="stat-row">
        <div class="value">{{ statistic.team.turnovers || 0 }}</div>
        <div class="name">Потери</div>
        <div class="value">{{ statistic.competitorTeam.turnovers || 0 }}</div>
      </div>
      <div class="stat-row">
        <div class="value">{{ statistic.team.blocks || 0 }}</div>
        <div class="name">Блокшоты</div>
        <div class="value">{{ statistic.competitorTeam.blocks || 0 }}</div>
      </div>
    </ng-container>
    <div class="stat-row">
      <div class="value">{{ statistic.team.totalFouls || 0 }}</div>
      <div class="name">Фолы</div>
      <div class="value">{{ statistic.competitorTeam.totalFouls || 0 }}</div>
    </div>
  </div>
</div>
